import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { shadowLg } from '../../../../web/styles/shadows';

const AVATAR_SIZE = 26;

export const ticketHoverPopoverStyles = StyleSheet.create({
	anchor: {
		display: 'inline-block',
		maxWidth: '100%',
	},
	popover: {
		width: 380,
		maxWidth: 'calc(100vw - 24px)',
		padding: 0,
		// The popover portals to the body, so the desk's Sora base (inboxStyles.desk) doesn't reach it.
		fontFamily: THEME.typography.fontFamilies.sora,
		borderColor: THEME.colors.border.light,
		boxShadow: shadowLg,
	},
	body: {
		padding: '14px 16px',
	},
	sectionLabel: {
		fontSize: 10,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: '0.07em',
		textTransform: 'uppercase',
		color: THEME.colors.text.light,
		marginBottom: 8,
	},
	senderRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 9,
		marginBottom: 8,
	},
	senderAvatar: {
		width: AVATAR_SIZE,
		height: AVATAR_SIZE,
		flex: 'none',
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.light,
	},
	senderName: {
		flex: 1,
		minWidth: 0,
		fontSize: 13,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		...THEME.common.truncate,
	},
	senderYou: {
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.light,
	},
	senderTime: {
		flex: 'none',
		fontSize: THEME.typography.fontSizes.xxs,
		color: THEME.colors.text.light,
	},
	messageText: {
		// @ts-expect-error Aphrodite's types omit WebKit line clamping.
		display: '-webkit-box',
		WebkitLineClamp: 3,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
		fontSize: 13,
		lineHeight: 1.5,
		color: THEME.colors.text.main,
	},
	divider: {
		display: 'flex',
		alignItems: 'center',
		gap: 10,
		margin: '14px 0',
	},
	dividerLine: {
		flex: 1,
		height: 1,
		backgroundColor: THEME.colors.border.light,
	},
	dividerLabel: {
		flex: 'none',
		fontSize: THEME.typography.fontSizes.xxs,
		color: THEME.colors.text.light,
		whiteSpace: 'nowrap',
	},
	state: {
		padding: '18px 0',
		textAlign: 'center',
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
});
